<template>
  <span>
    <!-- input file hidden -->
    <input
      type="file"
      name="fileInput"
      style="display:none;"
      ref="fileInput"
      @change="uploadFile($event)">
    <vs-button
      class="small"
      @click="showUploadDialog()">{{label}}</vs-button>
  </span>
</template>

<script>
export default {
  name: "FileUploader",
  props: {
    label: {
      type: String,
      required: true
    },
    endpointUploadFile: {
      type: String,
      required: true
    }
  },
  methods: {
    async uploadFile(ev) {
      try {
        let data = new FormData();
        data.append("file", ev.target.files[0]);
        let response = await axios.post(this.endpointUploadFile, data, {"Content-Type": "multipart/form-data"})
        this.$emit('onFileUploadedSuccess', response)
      } catch (e) {
        this.$emit('onFileUploadedFailed', e)
      }
    },
    showUploadDialog() {
      $(this.$refs.fileInput).click()
    },
  }
}
</script>

<style scoped>

</style>
